import api from '@/api/axios';

export default {
    async login(email, password) {
        try {
            const response = await api.post("/login", {
                email,
                password,
            });    
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    async logout() {
        try {
            const response = await api.post("/logout");
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
}